import React, { useState } from "react";
import "../CustomCSS/BookingOP.css";

const BookingOP = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    date: "",
    time: "",
    reason: ""
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const timeSlots = [
    "09:00 AM", "09:30 AM", "10:00 AM", "10:30 AM",
    "11:00 AM", "11:30 AM", "02:00 PM", "02:30 PM",
    "03:00 PM", "03:30 PM", "04:00 PM", "04:30 PM"
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("OP Booking:", formData);

    // TODO: send email / save appointment (EmailJS / API) before confirming
    // If that fails, show error — for now we assume success and show confirmation
    setIsSubmitted(true);
  };

  const handleClose = () => {
    // call modal close if provided
    if (typeof onClose === "function") {
      onClose();
    } else {
      // fallback: reset state and keep component in page
      setIsSubmitted(false);
      setFormData({
        name: "",
        email: "",
        phone: "",
        date: "",
        time: "",
        reason: ""
      });
    }
  };

  const handleNewBooking = () => {
    setIsSubmitted(false);
    setFormData({
      name: "",
      email: "",
      phone: "",
      date: "",
      time: "",
      reason: ""
    });
  };

  const getMinDate = () => new Date().toISOString().split("T")[0];

  if (isSubmitted) {
    return (
      <div className="booking-success booking-success--modal">
        <div className="success-card">
          <div className="success-icon-wrap">
            <svg className="success-check" width="72" height="72" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle cx="12" cy="12" r="11" stroke="#4CAF50" strokeWidth="1.6" fill="rgba(76,175,80,0.06)"/>
              <path d="M7.5 12.5l2.5 2.5L16.5 9" stroke="#2e7d32" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          <h2 className="success-title">Booking Confirmed!</h2>
          <p className="success-desc">
            Thank you for choosing Supatham Ayurvedhic Hospital. We will contact you shortly to confirm your appointment.
          </p>

          <div className="success-actions">
            <button className="btn-secondary" onClick={handleNewBooking}>Make another booking</button>
            <button className="btn-primary" onClick={handleClose}>Close</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id='bookingop' className="booking-container">
      <div className="booking-card">
        <h2 className="booking-title">Book an Appointment</h2>
        <p className="booking-subtitle">Schedule your visit quickly and easily</p>

        <form className="booking-form" onSubmit={handleSubmit}>

          {/* Row 1 - Name & Email */}
          <div className="form-row two-cols">
            <div className="form-group">
              <label htmlFor="name">Full Name *</label>
              <input id="name" type="text" name="name" value={formData.name} onChange={handleInputChange} required />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input id="email" type="email" name="email" value={formData.email} onChange={handleInputChange}  />
            </div>
          </div>

          {/* Row 2 - Phone | Date | Time (three columns) */}
          <div className="form-row three-cols">
            <div className="form-group">
              <label htmlFor="phone">Phone Number *</label>
              <input id="phone" type="tel" name="phone" value={formData.phone} onChange={handleInputChange} required />
            </div>

            <div className="form-group">
              <label htmlFor="date">Date *</label>
              <input id="date" type="date" name="date" value={formData.date} onChange={handleInputChange} min={getMinDate()} required />
            </div>

            <div className="form-group">
              <label htmlFor="time">Time *</label>
              <select id="time" name="time" value={formData.time} onChange={handleInputChange} required>
                <option value="">Select Time *</option>
                {timeSlots.map((time, idx) => <option key={idx} value={time}>{time}</option>)}
              </select>
            </div>
          </div>

          {/* Row 3 - Reason (full width) */}
          <div className="form-row full-row">
            <div className="form-group">
              <label htmlFor="reason">Reason / Symptoms</label>
              <textarea id="reason" name="reason" value={formData.reason} onChange={handleInputChange} rows="5"></textarea>
            </div>
          </div>

          <button type="submit" className="btn-booking">Book Appointment</button>
        </form>
      </div>
    </div>
  );
};

export default BookingOP;
